import React from "react"
import Button from "../bootstrap/button"
import addToMailchimp from "gatsby-plugin-mailchimp"

export default function Footer(props) {
  // Stores validation fail or mailchimp messages
  let mailMessage = ""

  // Tracks whether sumbnit button has been pressed
  let isPressed = false

  let timeout
  let timeoutSuccess

  function removeEmail() {
    const emailInputId = document.getElementById(props.inputId)
    emailInputId.value = ""
  }

  function handleChange() {
    // Reset all classes for another submission
    if (isPressed) {
      const emailInputId = document.getElementById(props.inputId)
      const messageID = document.getElementById(props.messageId)
      emailInputId.classList.remove("is-valid")
      emailInputId.classList.remove("is-invalid")
      emailInputId.classList.add("what?")
      messageID.classList.remove("valid-feedback")
      messageID.classList.add("invalid-feedback")
      isPressed = false
    }
  }

  function handleSubmit(event) {
    // All client side checking no server involved
    event.preventDefault()
    event.stopPropagation()
    if (!isPressed) {
      clearTimeout(timeout)
      clearTimeout(timeoutSuccess)

      const emailInputId = document.getElementById(props.inputId)
      const messageID = document.getElementById(props.messageId)
      // Remove any current error messages
      mailMessage = ""

      // Validate email (don't rely on browser validation)
      if (!emailInputId.value) {
        mailMessage = "Email address is required"
      } else if (!/\S+@\S+\.\S+/.test(emailInputId.value)) {
        mailMessage = "Email address is invalid"
      }

      // Before sending to Mailchimp check email validity
      if (mailMessage) {
        messageID.innerHTML = mailMessage
        emailInputId.classList.remove("is-valid")
        emailInputId.classList.add("is-invalid")
        timeout = setTimeout(handleChange, 5000)
        // Button submitted
        isPressed = true
      } else {
        // Sennd to mail chimp
        addToMailchimp(emailInputId.value).then(data => {
          if (data.result === "success") {
            messageID.innerHTML = "Thank you for subscribing!"
            emailInputId.classList.remove("is-invalid")
            emailInputId.classList.add("is-valid")
            messageID.classList.remove("invalid-feedback")
            messageID.classList.add("valid-feedback")
            timeout = setTimeout(handleChange, 5000)
            timeoutSuccess = setTimeout(removeEmail, 5000)
            const forms = document.querySelectorAll('.needs-validation')

            // Loop over them and prevent submission
            Array.from(forms).forEach(form => {
              form.addEventListener('submit', event => {
                if (!form.checkValidity()) {
                  event.preventDefault()
                  event.stopPropagation()
                }
          
                form.classList.add('was-validated')
              }, false)
            })
            // Button submitted
            isPressed = true
          } else if (data.result === "error") {
            mailMessage = data.msg
            messageID.innerHTML = mailMessage
            emailInputId.classList.remove("is-valid")
            emailInputId.classList.add("is-invalid")
            timeout = setTimeout(handleChange, 5000)
            // Button submitted
            isPressed = true
          }
        })
      }
    }
  }
  return (
    <>
      <form onSubmit={handleSubmit} onChange={handleChange} className="needs-validation" noValidate={true}>
        <div className="mb-3">
          <label htmlFor={props.inputId} className={`form-label text-dark${props.labelColor ? ` ${props.labelColor}`:''}`}>
            Email
            </label>
            <div className="input-group">
              <span className="input-group-text" id={props.prependId}>
                @
              </span>
              <input
              style = {{backgroundColor: "#fff"}}
                name="email"
                placeholder="Join Us"
                aria-describedby={props.inputId}
                required=""
                type="email"
                id={props.inputId}
                className="form-control"
              ></input>
              <div id={props.messageId} className="invalid-feedback">
                Please enter a valid email.
              </div>
            </div>
        </div>
        <Button size={props.size} type="submit" variant={props.variant}>
          Submit
        </Button>
      </form>
      {/* <Form noValidate onSubmit={handleSubmit} onChange={handleChange}>
        <Form.Group controlId={props.inputId} className="mb-3">
          <Form.Label className={props.labelColor}>Email</Form.Label>
          <InputGroup>
            <InputGroup.Text id={props.prependId}>@</InputGroup.Text>

            <Form.Control
              type="email"
              name="email"
              placeholder="Join Us"
              aria-describedby={props.inputId}
              required
            />
            <Form.Control.Feedback type="invalid" id={props.messageId}>
              Please enter a valid email.
            </Form.Control.Feedback>
          </InputGroup>
        </Form.Group>
 
      </Form> */}
    </>
  )
}
